export const LAYOUT_LEFTBAR_OPEN = 'LAYOUT_LEFTBAR_OPEN';
export const LAYOUT_LEFTBAR_CLOSE = 'LAYOUT_LEFTBAR_CLOSE';
export const LAYOUT_LEFTBAR_MODULE_OPEN = 'LAYOUT_LEFTBAR_MODULE_OPEN';
export const LAYOUT_LEFTBAR_MODULE_CLOSE = 'LAYOUT_LEFTBAR_MODULE_CLOSE';

export const LAYOUT_INBOX_OPEN = 'LAYOUT_INBOX_OPEN';
export const LAYOUT_INBOX_CLOSE = 'LAYOUT_INBOX_CLOSE';

export const LAYOUT_CHATDRAWER_OPEN = 'LAYOUT_CHATDRAWER_OPEN';
export const LAYOUT_CHATDRAWER_CLOSE = 'LAYOUT_CHATDRAWER_CLOSE';

export const LAYOUT_SNACKBAR_MESSAGE_SHOW = 'LAYOUT_SNACKBAR_MESSAGE_SHOW';
export const LAYOUT_SNACKBAR_MESSAGE_HIDE = 'LAYOUT_SNACKBAR_MESSAGE_HIDE';


export const openLeftBar = bar => ({ type: LAYOUT_LEFTBAR_OPEN, bar });
export const closeLeftBar = () => ({ type: LAYOUT_LEFTBAR_CLOSE });

export const openLeftBarModule = (bar, module, extra) => ({ type: LAYOUT_LEFTBAR_MODULE_OPEN, bar, module, extra });
export const closeLeftBarModule = bar => ({ type: LAYOUT_LEFTBAR_MODULE_CLOSE, bar });

/**
 * Inbox actions.
 */
export const inboxOpen = () => ({ type: LAYOUT_INBOX_OPEN });
export const inboxClose = () => ({ type: LAYOUT_INBOX_CLOSE });

/**
 * Chat drawer actions.
 */
export const openChatDrawer = () =>({ type: LAYOUT_CHATDRAWER_OPEN });
export const closeChatDrawer = () => ({ type: LAYOUT_CHATDRAWER_CLOSE });

/**
 * Snackbar actions.
 */
export const showSnackbarMessage = message => ({ type: LAYOUT_SNACKBAR_MESSAGE_SHOW, payload : message });
export const hideSnackbarMessage = () => ({ type: LAYOUT_SNACKBAR_MESSAGE_HIDE });
